module.exports = __webpack_public_path__ + "img/b3.2f3a275c.png";